<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Bonafide Certificate </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" persistent-hint
                        hint="Please Select Standard" />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined persistent-hint hint="Please Select Division" />
                </v-col>

                <v-col sm="2" v-if="sel_ay_data && sel_std_data && div">
                    <v-btn class="mt-6 button" @click="getbonafiedcertificates()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row> </v-row>
        </v-card>
        <template>
            <v-card class="box" v-if="data_list !=''">
                <v-card-title>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="data_list" class="elevation-1 mytable" dense :search="search">
                    <template v-slot:item.issued="{ item }">
                        <span v-if="item.issued">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:item.get="{ item }">
                        <v-btn class="pt-1 pb-1" rounded color="info" v-if="item.issued" small
                            :loading="show_cert_loader" @click="showCert(item)">Get Bonafide</v-btn>
                    </template>
                    <template v-slot:item.generate="{ item }">
                        <v-btn class="mt-1 mb-1" rounded color="warning" :loading="gen_cert_loader" small
                            @click="genCert(item)">Generate Bonafide</v-btn>
                    </template>
                </v-data-table>
            </v-card>
        </template>
        <template>
        </template>
    </div>
</template>

<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

        data() {
            return {
                snackbar: false,
                fetch_loader: false,
                gen_cert_loader: false,
                // extraBreadcrumbItems: [
                   

                // ],
                // breadcrumbClass: "breadcrumb-style1",
                show_cert_loader: false,
                search: "",
                dialog: false,
                awspath: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                data_list: [],
                ay_std_div_list: null,
                sel_ay_data: null,
                cert_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                overlay: false,
                org_basic_data:[],
                headers: [
                    {
                        text: "Sr. No.",
                        sortable: true,
                        value: "srno",
                    },
                    {
                        text: "Student Name",
                        align: "center",
                        sortable: true,
                        value: "name",
                    },
                    {
                        text: "PRNo",
                        align: "center",
                        sortable: true,
                        value: "prno",
                    },
                    {
                        text: "RollNo",
                        align: "center",
                        sortable: true,
                        value: "rollno",
                    },
                    {
                        text: "Issued",
                        align: "center",
                        sortable: true,
                        value: "issued",
                    },
                    {
                        text: "Issued Dates",
                        align: "center",
                        sortable: false,
                        value: "issued_dates",
                    },
                    {
                        text: "Get Issued Bonafide",
                        align: "center",
                        sortable: false,
                        value: "get",
                    },
                    {
                        text: "Generate Bonafide",
                        align: "center",
                        sortable: false,
                        value: "generate",
                    },
                ], 
            };
        },

        methods: {
            showCert(item) {
                const routeData = this.$router.resolve({
                name: 'get-certificate-zeal-bonafied',
                query: {
                cert_data: JSON.stringify(item.cert_data),
                org_basic_data: JSON.stringify(this.org_basic_data)
                }
            });
            window.open(routeData.href, '_blank');
            },
            genCert(item) {
                console.log("gen: ", item);
                this.gen_cert_loader = true;
                axios
                    .post("/certificate/genZealBonafideCert", item)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("success", res.data.snackbar);
                            this.cert_data = res.data.cert_data;
                            let index = this.data_list.indexOf(item);
                            this.data_list[index].cert_data = this.cert_data;
                            this.data_list[index].issued = true;
                            this.showCert(item)
                            //item.cert_data = this.cert_data
                            console.log(this.data_list[index]);
                        } else {
                            this.showSnackbar("error", res.data.snackbar);
                        }
                        this.dialog = true;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.gen_cert_loader = false;
                    })
                    .finally(() => {
                        this.gen_cert_loader = false;
                    });
            },
            getbonafiedcertificates() {
                let div = this.div.div_off_id;
                if (this.div.div_off_id) {
                    div = this.div.div_off_id;
                } else {
                    div = this.div;
                }

                const formdata = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    div_off_id: div,
                };
                this.fetch_loader = true;
                axios
                    .post("/certificate/getbonafiedcertificates", formdata)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("success", res.data.snackbar);
                            this.data_list = res.data.data_list;
                            this.org_basic_data = res.data.org_basic_data
                        } else {
                            this.showSnackbar("error", res.data.snackbar);
                        }
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                    });
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.curr_ay;
                    })
                    .catch((error) => {
                        this.onerror(error);
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.onload();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
     @media print {
        header,footer,nav,date { 
            display: none !important;
        }
        img {
            width: 100% !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        @page {
            size: 25.5in 20.5in;
        }
        * {
            overflow:hidden !important;
        };
    } 
</style>
